type ArrayDelta<T> = {
  more: T[]
  less: T[]
  same: T[]
}

/** The more/less results are what right has compared to left. */
export const getArrayDeltaBy = <T, K>(
  left: readonly T[],
  right: readonly T[],
  selectKey: (item: T) => K
): ArrayDelta<T> => {
  const leftKeys = new Set(left.map(selectKey))
  const rightKeys = new Set(right.map(selectKey))

  const moreKeys = new Set(rightKeys.difference(leftKeys))
  const lessKeys = new Set(leftKeys.difference(rightKeys))
  const sameKeys = new Set(leftKeys.intersection(rightKeys))

  return {
    more: right.filter((item) => moreKeys.has(selectKey(item))),
    less: left.filter((item) => lessKeys.has(selectKey(item))),
    same: right.filter((item) => sameKeys.has(selectKey(item))), // keep `right` order
  }
}

export function getArrayDelta<T>(
  left: readonly T[],
  right: readonly T[]
): ArrayDelta<T>
export function getArrayDelta<T, K>(
  left: readonly T[],
  right: readonly T[],
  selectKey: (item: T) => K
): ArrayDelta<T>
export function getArrayDelta<T, K>(
  left: readonly T[],
  right: readonly T[],
  selectKey?: (item: T) => K
): ArrayDelta<T> {
  const keyFn = (selectKey ?? ((x: T) => x)) as (item: T) => K
  return getArrayDeltaBy(left, right, keyFn)
}
